import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from '@/helpers/Auth/authService';

import { AppRouter } from '@/routes/AppRouter';
import { DEFAULT_INTL } from '@/utils/constants/globalConstants';
import { AuthProvider } from '@/context/Auth/AuthProvider';
import useInternationalization from '@/internationalization/useInternationalization';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { IntlProvider } from 'react-intl';
import './assets/scss/App.scss';
import { store, persistor } from '@/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from 'pepsico-ds';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import gb from '@/utils/growthbookUtils';
import { useSetCSSVariables } from '@/utils/constants/colors';



const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0
    }
  }
});


function App ({ shellActive = false, darkTheme = true, path = '' }) {
  const [language, message] = useInternationalization(DEFAULT_INTL);
  useSetCSSVariables();
  return (
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <GrowthBookProvider growthbook={gb}>
          <QueryClientProvider client={queryClient}>
            <IntlProvider locale={language} messages={message}>
              <AuthProvider>
                <ThemeProvider defaultStyle="Dark Peacock">
                  <AppRouter
                    shellActive={shellActive}
                    darkTheme={darkTheme}
                    path={path}
                  />
                </ThemeProvider>
              </AuthProvider>
            </IntlProvider>
          </QueryClientProvider>
        </GrowthBookProvider>
      </PersistGate>
    </Provider>
    </MsalProvider>
    
  );
}

export default App;
